import Vue from "vue";
import Router from "vue-router";
import Start from "./views/Start.vue";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: "/",
            name: "Home",
            title: "Ganz im Vertrauen | Dr Thumm GmbH",
            component: () => import("./views/Home.vue"),
            metaTags: [
                {
                    name: 'description',
                    content: 'Die Dr. Thumm GmbH ist die Beratungsagentur, die Potenziale entfaltet. Unsere Agentur bietet Ihnen ein maßgeschneidertes Konzept zur Unterstützung bei der Personalentwicklung durch Recruiting, Training, Coaching und Moderation.'
                },
            ]
        },
        {
            path: "/moderation/*",
            name: "Moderation",
            component: () => import("./views/Moderation.vue")
        },
        {
            path: "/recruiting*",
            name: "Recruiting",
            component: () => import("./views/Recruiting.vue")
        },
        {
            path: "/training*",
            name: "Training",
            component: () => import("./views/Training.vue")
        },
        {
            path: "/coaching*",
            name: "Coaching",
            component: () => import("./views/Coaching.vue")
        },
        {
            path: "/kultur*",
            name: "Kultur",
            component: () => import("./views/Kultur.vue")
        },
        {
            path: "/kontakt*",
            name: "Kontakt",
            component: () => import("./views/Kontakt.vue")
        },
        {
            path: "/mind*",
            name: "M.I.N.D",
            component: () => import("./views/MIND.vue")
        },
        {
            path: "/impressum*",
            name: "Impressum",
            component: () => import("./views/Impressum.vue")
        },
        {
            path: "/datenschutz*",
            name: "Datenschutz",
            component: () => import("./views/Datenschutz.vue")
        },
        {
            path: "/new-thinking",
            name: "newThinking",
            component: () => import("./views/NewThinking.vue")
        },
        {
            path: "*",
            name: "PageNotFound",
            component: () => import("./views/PageNotFound.vue")
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.fullPath === "/") document.body.className = "landingpage"
    else document.body.className = ""
    next()
})

export default router
